import { UserDataUpdate } from "../../types/authTypes";
import { Image, NewShirt } from "../shirts/types";
import {
  postCall,
  getCall,
  putCall,
  patchCall,
  HeadersInterface,
  BodyParamsInterface,
  convertInterfaceToBodyParams,
  QueryParamsInterface,
} from "./api";

const BASE_URL = "v1/tops";

export const getTopUsersByNumber = async (
  limit: number,
  page: number,
  startDate?: string | undefined,
  endDate?: string | undefined,
) => {
  let url = BASE_URL + "/collections";
  let headers: HeadersInterface | undefined;
  let params: string = "perPage=" + limit;
  params += "&page=" + page;

  if (startDate) {
    params += "&start_date=" + startDate;
  }

  if (endDate) {
    params += "&end_date=" + endDate;
  }

  let response = await getCall(url, headers, params);

  return response;
};

export const getTopTeams = async (limit: number, page: number) => {
  let url = BASE_URL + "/teams";
  let headers: HeadersInterface | undefined;
  let params: string = "perPage=" + limit;
  params += "&page=" + page;

  let response = await getCall(url, headers, params);

  return response;
};

export const getTopPlayers = async (limit: number, page: number) => {
  let url = BASE_URL + "/players";
  let headers: HeadersInterface | undefined;
  let params: string = "perPage=" + limit;
  params += "&page=" + page;

  let response = await getCall(url, headers, params);

  return response;
};
